import { useContext } from 'react';

import { ProductItemContext } from '@/providers/productItem';
import { ProductListContext } from '@/providers/productList';
import useProductStore from '@/store/product';
import { buriedPoint } from '@/utils/buriedPoint';

// 数据手册按钮
export default function DatasheetButton() {
  const { updateDatasheetData } = useProductStore();
  const { searchResult } = useContext(ProductListContext);
  const { index, productVO, rs_log } = useContext(ProductItemContext);

  function openDatasheet() {
    buriedPoint({
      op: 'click_pdf',
      data: {
        pc: productVO?.productId,
        brand: productVO?.productGradePlateName,
        model: productVO?.productModel,
        code: productVO?.productCode,
        kw: searchResult?.globalSearchKeyword,
        cp: searchResult?.currePage,
        ix: index,
        rs_log,
      },
    });
    updateDatasheetData({
      open: true,
      product: {
        productId: productVO?.productId,
        productModel: productVO?.productModel,
        productCode: productVO?.productCode,
        pdfDESProductId: productVO?.pdfDESProductId,
      },
    });
  }

  return (
    productVO?.fileTypeVOList?.length > 0 && (
      <button
        className="mr-[10px] flex h-[26px] w-[95px] items-center justify-center rounded-[13px] bg-[#F5F6F9] text-[#333] hover:bg-[#ECEEF0]"
        onClick={openDatasheet}
      >
        <i className="mr-[5px] inline-block h-[18px] w-[17px] bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/so/pdf.svg)] bg-no-repeat"></i>
        <span>数据手册</span>
      </button>
    )
  );
}
